import { ICartProduct } from '@/store/ducks/order/types';
import { IProduct } from '@/store/ducks/products/types';

import { DeviceType } from './types';

export const getDimensionsByDevice = (device: DeviceType) => ({
  height: device === 'mobile' ? 'auto' : '250px',
  width: device === 'mobile' ? '100%' : '13.75rem',
});

export const calculateDiscountPrice = (price: number, discountPercentage: number): number => {
  return price - price * (discountPercentage / 100);
};

export const shouldShowVariations = (variationsCount: number): boolean => {
  return variationsCount > 1;
};

export const getQuantitiesOnEdit = (
  products: IProduct[] | ICartProduct[],
  setQuantities: React.Dispatch<React.SetStateAction<Record<number, number>>>,
) => {
  products.forEach(({ id, quantity }) => {
    setQuantities((prev) => ({
      ...prev,
      [id]: quantity,
    }));
  });
};
